import * as React from "react";

export const TransferLeadIcon = (props: any) => (
  <svg
    width={56}
    height={56}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill="#D1FADF" />
    <path
      d="M32.05 28.05 37 33l-4.95 4.95-1.414-1.414 2.536-2.537L20 34v-2h13.172l-2.536-2.536 1.414-1.414Zm-8.1-10 1.414 1.414L22.828 22H36v2H22.828l2.536 2.536-1.414 1.414L19 23l4.95-4.95Z"
      fill="#333"
    />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke="#ECFDF3"
      strokeWidth={8}
    />
  </svg>
);
